module.exports = __webpack_public_path__ + "img/tab20.8cadc321.png";